import { createFileRoute } from '@tanstack/react-router';
import { FirmwarePage } from '@/features/device-models/components/firmware/FirmwarePage';

interface FirmwareSearchParams {
  page?: number;
  pageSize?: number;
  firmwareTypeIds?: string;
  countryId?: string;
}

export const Route = createFileRoute('/_app/device-models/$modelId/firmware')({
  component: FirmwarePage,
  validateSearch: (search: Record<string, unknown>): FirmwareSearchParams => {
    return {
      page: search.page ? Number(search.page) : undefined,
      pageSize: search.pageSize ? Number(search.pageSize) : undefined,
      firmwareTypeIds: search.firmwareTypeIds ? String(search.firmwareTypeIds) : undefined,
      countryId: search.countryId as string | undefined,
    };
  },
});
